import { createSlice } from "@reduxjs/toolkit";

export const FullCalendar = createSlice({
  name: "fullCalendar",
  initialState: {
    renderedEvents: [],
    loggedUserEvents: [],
    selectedDates: [],
  },
  reducers: {
    setRenderedEventList: (state, action) => {
      state.renderedEvents = action.payload;
    },

    setSelectedDates: (state, action) => {
      state.selectedDates = action.payload;
    },

    setLoggedUsersEventList: (state, action) => {
      state.loggedUserEvents = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setRenderedEventList,
  setSelectedDates,
  setLoggedUsersEventList,
} = FullCalendar.actions;

export default FullCalendar.reducer;
